import { PropsWithChildren } from "react";
import styles from "./FileSelector.module.css";

interface FileSelectorContainerProps {
    className?: string;
    style?: React.CSSProperties;
}

export const FileSelectorContainer = (props: PropsWithChildren<FileSelectorContainerProps>) => {
    const { children, className, style } = props;

    const combinedClassName = className ? `${styles.FileSelectorContainer} ${className}` : styles.FileSelectorContainer;

    return (
        <ul className={combinedClassName} style={style}>
            {children}
        </ul>
    );
};
